<div class="gw-w-full gw-max-w-4xl gw-mx-auto gw-max-h-[70vh]">
  <div class="gw-space-y-6 gw-p-x-large">
    <p class="gw-text-text-primary gw-text-base">
      {{
        'features.settings.parameters.providersBaseFees.description' | translate
      }}
    </p>

    <section class="gw-space-y-2">
      <h3 class="gw-text-sm gw-font-medium gw-text-text-primary">
        {{
          'features.settings.parameters.providersBaseFees.configuredProviders'
            | translate
        }}
      </h3>
      <p
        *ngIf="configuredProviders.length === 0"
        class="gw-text-sm gw-text-text-secondary"
      >
        {{
          'features.settings.parameters.providersBaseFees.noProvidersConfigured'
            | translate
        }}
      </p>
      <ul
        *ngIf="configuredProviders.length > 0"
        class="gw-space-y-2 gw-list-none"
      >
        <li
          *ngFor="let p of configuredProviders"
          class="gw-flex gw-flex-wrap gw-items-center gw-gap-2 gw-p-2 gw-rounded-md gw-bg-background-elevation-1"
        >
          <span class="gw-font-medium gw-uppercase gw-text-sm">{{ p }}</span>
          <button
            type="button"
            class="gw-text-sm gw-text-primary gw-underline"
            (click)="editProvider(p)"
          >
            {{
              'features.settings.parameters.providersBaseFees.editProvider'
                | translate
            }}
          </button>
          <button
            type="button"
            class="gw-text-sm gw-text-status-negative"
            (click)="removeProvider(p)"
          >
            {{
              'features.settings.parameters.providersBaseFees.removeProvider'
                | translate
            }}
          </button>
        </li>
      </ul>
    </section>

    <section
      *ngIf="addProviderItems.length > 0"
      class="gw-flex gw-flex-wrap gw-gap-3 gw-items-end gw-border gw-border-border-normal gw-rounded-lg gw-p-4"
    >
      <div class="gw-min-w-[200px] gw-flex-1">
        <gatewee-select-v3
          [formControl]="providerToAdd"
          [items]="addProviderItems"
          [label]="
            'features.settings.parameters.providersBaseFees.selectProvider'
              | translate
          "
          inputId="pbf-provider-add"
          [placeholder]="
            'features.settings.parameters.providersBaseFees.selectPlaceholder'
              | translate
          "
        ></gatewee-select-v3>
      </div>
      <gatewee-button
        variant="outline"
        type="button"
        [title]="
          'features.settings.parameters.providersBaseFees.addProvider'
            | translate
        "
        (clicked)="addProvider()"
        [disabled]="!providerToAdd.value || submitting"
      ></gatewee-button>
    </section>

    <form
      *ngIf="activeProvider"
      [formGroup]="feeForm"
      class="gw-space-y-4 gw-border gw-border-border-normal gw-rounded-lg gw-p-4"
    >
      <h3 class="gw-text-sm gw-font-medium gw-text-text-primary gw-uppercase">
        {{ activeProvider }}
      </h3>
      <div formArrayName="rows" class="gw-space-y-4">
        <div
          *ngFor="let ctrl of feeRows.controls; let i = index"
          [formGroupName]="i"
          class="gw-flex gw-flex-wrap gw-gap-3 gw-items-end gw-p-3 gw-bg-background-elevation-1 gw-rounded-md"
        >
          <div class="gw-min-w-[120px] gw-flex-1">
            <gatewee-select-v3
              [items]="feeTypeItems"
              formControlName="type"
              [label]="
                'features.settings.parameters.providersBaseFees.row.type'
                  | translate
              "
              [inputId]="'pbf-' + activeProvider + '-type-' + i"
            ></gatewee-select-v3>
          </div>
          <div class="gw-min-w-[100px] gw-w-28">
            <gatewee-input-v2
              [form]="feeRows.at(i)"
              controlName="value"
              type="decimal"
              [label]="
                'features.settings.parameters.providersBaseFees.row.value'
                  | translate
              "
              [id]="'pbf-' + activeProvider + '-val-' + i"
            ></gatewee-input-v2>
          </div>
          <div class="gw-min-w-[140px] gw-flex-1">
            <gatewee-select-v3
              [items]="paymentMethodItems"
              formControlName="paymentMethod"
              [label]="
                'features.settings.parameters.providersBaseFees.row.paymentMethod'
                  | translate
              "
              [inputId]="'pbf-' + activeProvider + '-pm-' + i"
            ></gatewee-select-v3>
          </div>
          <div
            *ngIf="
              feeRows.at(i).get('paymentMethod')?.value ===
              PaymentMethod.CREDIT_CARD
            "
            class="gw-min-w-[120px] gw-flex-1"
          >
            <gatewee-select-v3
              [items]="installmentItems"
              formControlName="installments"
              [label]="
                'features.settings.parameters.providersBaseFees.row.installments'
                  | translate
              "
              [inputId]="'pbf-' + activeProvider + '-inst-' + i"
            ></gatewee-select-v3>
          </div>
          <div class="gw-min-w-[140px]">
            <gatewee-select-v3
              [items]="flowItems"
              formControlName="operation"
              [label]="
                'features.settings.parameters.providersBaseFees.row.operation'
                  | translate
              "
              [inputId]="'pbf-' + activeProvider + '-op-' + i"
            ></gatewee-select-v3>
          </div>
          <button
            type="button"
            class="gw-text-status-negative gw-text-sm"
            (click)="removeRow(i)"
            *ngIf="feeRows.length > 1"
          >
            {{ 'common.actions.remove' | translate }}
          </button>
        </div>
      </div>
      <button
        type="button"
        class="gw-text-sm gw-text-primary gw-underline"
        (click)="addRow()"
      >
        {{
          'features.settings.parameters.providersBaseFees.addRow' | translate
        }}
      </button>
      <div>
        <gatewee-button
          variant="outline"
          type="button"
          [title]="
            'features.settings.parameters.providersBaseFees.applyProvider'
              | translate
          "
          (clicked)="apply()"
          [disabled]="submitting"
        ></gatewee-button>
      </div>
    </form>

    <div class="gw-flex gw-justify-end gw-gap-3 gw-pt-4">
      <gatewee-button
        variant="outline"
        [title]="'common.actions.cancel' | translate"
        (clicked)="close()"
        [disabled]="submitting"
      ></gatewee-button>
      <gatewee-button
        variant="primary"
        [title]="
          'features.settings.parameters.providersBaseFees.send' | translate
        "
        type="button"
        (clicked)="onSend()"
        [disabled]="submitting || (!!activeProvider && feeForm.invalid)"
      ></gatewee-button>
    </div>
  </div>
</div>
